import axios from 'axios'
import { ErrorWrapper } from '@utils/error-handler'

export const actions = {
  sendEmail({ userData }) {
    return axios
      .get(`${process.env.VUE_APP_API_BASE_URL}/email/cron`, userData)
      .then((response) => {
        const message = response.data
        return message
      })
      .catch((error) => {
        return new ErrorWrapper(error)
      })
  },
}
